import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { ShopWindowItem } from '../../model/shop-window-item';

@Component({
    selector: 'pme-product-descomplica',
    templateUrl: './product-descomplica.component.html',
    styleUrls: ['./product-descomplica.component.scss'],
    standalone: false
})
export class ProductDescomplicaComponent implements OnInit {

  @Input() productData: ShopWindowItem;
  @Output() clickOnProduct = new EventEmitter<void>();
  @Input() periodicity: string;

  constructor() { }

  ngOnInit(): void {
  }

  getValue(type: string): string {
    switch (type) {
      case 'baseValue':
        return this.productData.baseValue.toFixed(2).replace('.', ',');
      case 'monthlyValue':
        return this.productData.paymentMethods.find(paymentMethod => paymentMethod.identifier === 'ADYEN')?.maxInstallmentValue.toFixed(2).replace('.', ',');
      case 'totalValue':
        return this.productData.totalValue.toFixed(2).replace('.', ',');
      default:
        console.warn(`Unknown type: ${type}`);
        return '';
    }
  }

  isAppliedDiscounts(): boolean {
    return this.productData.appliedDiscounts && this.productData.appliedDiscounts.length > 0;
  }

  onClick(): void {
    this.clickOnProduct.emit();
  }

}
